'use strict';

exports.__esModule = true;
var POSITIONS = exports.POSITIONS = ['left', 'top', 'right', 'bottom'];


//////////////////
// WEBPACK FOOTER
// ./node_modules/redux-devtools-dock-monitor/lib/constants.js
// module id = 243
// module chunks = 0